/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessTypeMonthlyStat
 */
export interface BusinessTypeMonthlyStat {
    /**
     * 业务类型名称
     * @type {string}
     * @memberof BusinessTypeMonthlyStat
     */
    typeName?: string;
    /**
     * 订单数量
     * @type {number}
     * @memberof BusinessTypeMonthlyStat
     */
    count?: number;
    /**
     * 占比(%)
     * @type {number}
     * @memberof BusinessTypeMonthlyStat
     */
    percentage?: number;
    /**
     * 环比上月增长率(%)
     * @type {number}
     * @memberof BusinessTypeMonthlyStat
     */
    momGrowthRate?: number;
}

/**
 * Check if a given object implements the BusinessTypeMonthlyStat interface.
 */
export function instanceOfBusinessTypeMonthlyStat(value: object): value is BusinessTypeMonthlyStat {
    return true;
}

export function BusinessTypeMonthlyStatFromJSON(json: any): BusinessTypeMonthlyStat {
    return BusinessTypeMonthlyStatFromJSONTyped(json, false);
}

export function BusinessTypeMonthlyStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessTypeMonthlyStat {
    if (json == null) {
        return json;
    }
    return {
        
        'typeName': json['typeName'] == null ? undefined : json['typeName'],
        'count': json['count'] == null ? undefined : json['count'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'momGrowthRate': json['momGrowthRate'] == null ? undefined : json['momGrowthRate'],
    };
}

export function BusinessTypeMonthlyStatToJSON(json: any): BusinessTypeMonthlyStat {
    return BusinessTypeMonthlyStatToJSONTyped(json, false);
}

export function BusinessTypeMonthlyStatToJSONTyped(value?: BusinessTypeMonthlyStat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'typeName': value['typeName'],
        'count': value['count'],
        'percentage': value['percentage'],
        'momGrowthRate': value['momGrowthRate'],
    };
}

